// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[type=date]:not(:valid)::-webkit-datetime-edit{color:transparent}input[type=date]:not(:valid){color:transparent}input[type=date]:focus:not(:valid)::-webkit-datetime-edit,input[type=date]:valid::-webkit-datetime-edit{color:inherit}input[type=date]:focus:not(:valid),input[type=date]:valid{color:inherit}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
